import React from 'react';

export function CancellationsSVG ({ className = '', selected = false }) {
    return (
        <span className={className}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clipPath="url(#clip0_6405_11831)">
                    <path d="M3 3L21 21" stroke="#F4AB34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 5H18C18.7956 5 19.5587 5.31607 20.1213 5.87868C20.6839 6.44129 21 7.20435 21 8V16C21.0003 16.2947 20.9572 16.5879 20.872 16.87" stroke="#F4AB34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M18.87 18.8719C18.5879 18.9571 18.2947 19.0002 18 18.9999H6C5.20435 18.9999 4.44129 18.6838 3.87868 18.1212C3.31607 17.5586 3 16.7955 3 15.9999V7.99988C3 6.64788 3.894 5.50488 5.124 5.12988" stroke="#F4AB34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M3 11H11" stroke="#F4AB34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M15 11H21" stroke="#F4AB34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7 15H7.01" stroke="#F4AB34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M11 15H13" stroke="#F4AB34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_6405_11831">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
}
